module.exports = __webpack_public_path__ + "img/MC.571f0da3.svg";